import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { Hero } from "@/components/home/HeroSlider";
import { NextSteps } from "@/components/home/NextSteps";
import { DevotionalPopup } from "@/components/home/DevotionalPopup";
import { DevotionalToday } from "@/components/home/DevotionalToday";
import { WelcomeBack } from "@/components/home/WelcomeBack";
import { VisitSection, JesusSection, GroupsSection, ServeSection, EventsSection } from "@/components/home/Sections";
import { useVisitor } from "@/lib/visitor";
import { intentById, DEFAULT_EXPERIENCE } from "@/lib/intents";

const SECTIONS = {
  devotional: DevotionalToday, visit: VisitSection, jesus: JesusSection,
  groups: GroupsSection, serve: ServeSection, events: EventsSection,
};

export default function Home() {
  const { intent, openQuestionnaire } = useVisitor();
  const { hash } = useLocation();
  const order = (intentById(intent) || DEFAULT_EXPERIENCE).order;

  useEffect(() => {
    if (intent || localStorage.getItem("vp_prompted")) return;
    const t = setTimeout(openQuestionnaire, 1500);
    return () => clearTimeout(t);
  }, [intent, openQuestionnaire]);

  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [hash]);

  return (
    <div data-testid="home-page">
      <SiteHeader />
      <Hero />
      <WelcomeBack />
      <NextSteps />
      {order.filter((k) => SECTIONS[k]).map((k) => { const S = SECTIONS[k]; return <S key={k} />; })}
      <DevotionalPopup />
      <SiteFooter />
    </div>
  );
}
